/* eslint-disable @typescript-eslint/camelcase */

import Feedable from '@/global/dejaVue/feedable'

export default class SuiviCAModel extends Feedable {
    public commercial = null as string | null
    public dr = null as string | null
    public businessUnit = '' as string
    public client = null as string[] | null
    public chiffreAffaireAnneeN = 0
    public chiffreAffaireAnneeN1 = 0
    public chiffreAffaireAnneeN2 = 0
    public ytD_N = 0
    public ytD_N1 = 0
    public kitDepot = ''
    public remise = 0

    public feed(options?: Partial<SuiviCAModel>) {
        if (options?.chiffreAffaireAnneeN) this.chiffreAffaireAnneeN = options.chiffreAffaireAnneeN
        if (options?.chiffreAffaireAnneeN1) this.chiffreAffaireAnneeN1 = options.chiffreAffaireAnneeN1
        if (options?.chiffreAffaireAnneeN2) this.chiffreAffaireAnneeN2 = options.chiffreAffaireAnneeN2
        if (options?.ytD_N) this.ytD_N = options.ytD_N
        if (options?.ytD_N1) this.ytD_N1 = options.ytD_N1
        if (options?.kitDepot) this.kitDepot = options.kitDepot
        if (options?.remise) this.remise = options.remise

        return this
    }
}
